/** Shopify CDN: Minification failed

Line 34:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 35:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 35:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 36:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 36:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 38:42 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 45:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 23:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 24:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 24:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 25:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 25:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 27:42 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 34:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 12:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 13:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 13:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 14:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 14:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 16:42 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 23:14 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
(async () => {
    const { Core } = await importModule('Core');
    const { Plyr } = await importModule('Plyr');

    customElements.define('video-player', class extends Core {

        elements = {
            embeddedPlayer: '[data-player]',
            HTML5Player: 'video'
        }

        render() {
            this.player = new Plyr(this.$player, {
                ratio: '16:9'
            });
        }

        get $player() {
            return this.$embeddedPlayer || this.$HTML5Player
        }
    })
})();
